import { payrollRunApiBaseUrl } from '../../shared/env';
import { createJsonClient } from '../../shared/httpClient';
import type { PayrollReviewGateway } from './PayrollReviewGateway';
import type { PayrollReviewRun, PayrollRunCalculation } from './types';

export class HttpPayrollReviewGateway implements PayrollReviewGateway {
  private readonly request = createJsonClient(payrollRunApiBaseUrl);

  listRuns(signal?: AbortSignal): Promise<PayrollReviewRun[]> {
    return this.request('/api/payroll-runs', undefined, signal);
  }

  getRun(id: string, signal?: AbortSignal): Promise<PayrollReviewRun> {
    return this.request(`/api/payroll-runs/${encodeURIComponent(id)}`, undefined, signal);
  }

  listRunCalculations(id: string, signal?: AbortSignal): Promise<PayrollRunCalculation[]> {
    return this.request(`/api/payroll-runs/${encodeURIComponent(id)}/calculations`, undefined, signal);
  }

  // Approve takes no body. The server decides everything — permission, PendingApproval state, and the three
  // segregation-of-duties rules; a refusal arrives as 400 (rule/state) or 403 (permission).
  approveRun(id: string): Promise<PayrollReviewRun> {
    return this.request(`/api/payroll-runs/${encodeURIComponent(id)}/approve`, { method: 'POST' });
  }

  rejectRun(id: string, reason: string): Promise<PayrollReviewRun> {
    return this.request(`/api/payroll-runs/${encodeURIComponent(id)}/reject`, {
      method: 'POST',
      body: JSON.stringify({ reason }),
    });
  }
}
